import type { BuiltinConnectorDefinition } from '#layers/data-model/types/data-connectors/define';
import mariadb from './mariadb';
import mssql from './mssql';
import mysql from './mysql';
import postgres from './postgres';
import { mariadbPresets } from './presets/mariadb';
import { mysqlPresets } from './presets/mysql';
import { postgresPresets } from './presets/postgres';
import sqlite from './sqlite';

export const dataConnectorDefinitions = [
	postgres,
	mysql,
	mariadb,
	mssql,
	sqlite,
	...postgresPresets,
	...mysqlPresets,
	...mariadbPresets,
] satisfies BuiltinConnectorDefinition<any, any>[];
